import { render, staticRenderFns } from "./Tresoreries.vue?vue&type=template&id=2b0585e3&scoped=true&"
import script from "./Tresoreries.js?vue&type=script&lang=js&"
export * from "./Tresoreries.js?vue&type=script&lang=js&"
import style0 from "./Tresoreries.vue?vue&type=style&index=0&id=2b0585e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0585e3",
  null
  
)

export default component.exports